import React from 'react'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'

// This component is the "Portfolio Fleets Miles by Zip" tab — MILES_BY_ZIP is the correct flag despite the generic file name.
const PortfolioDashboard: React.FC = () => {
  return <ConsoleEmbed reportKey={REPORT_KEYS.MILES_BY_ZIP} fullHeight />
}

export default PortfolioDashboard
